import axios from 'axios';

// Guarda para evitar redirecionamentos múltiplos quando várias requisições retornam 401/403 em paralelo
let authRedirectInProgress = false;

function isJwtExpired(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload || !payload.exp) return null;
    return payload.exp < Math.floor(Date.now() / 1000);
  } catch (e) {
    return null;
  }
}

axios.interceptors.request.use(
  (config) => {
    try {
      // Não adicionar headers para endpoints públicos
      const isPublicEndpoint =
        config.url?.includes('/auth') ||
        config.url?.includes('/usuario/salvar') ||
        config.url?.includes('/publico/');
      
      if (!isPublicEndpoint) {
        const cnpj = localStorage.getItem('cnpj');
        if (cnpj) {
          config.headers = config.headers || {};
          config.headers['X-Associacao-CNPJ'] = cnpj;
        }
      }
      
      const token = localStorage.getItem('token');
      if (token && !isPublicEndpoint) {
        config.headers = config.headers || {};
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      }
    } catch (e) {
      // ignore
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;

// Interceptor global para capturar erros de autenticação e redirecionar para login
axios.interceptors.response.use(
  response => response,
  error => {
    try {
      const status = error && error.response && error.response.status;
      if (status === 401) {
        if (!authRedirectInProgress) {
          authRedirectInProgress = true;
          const currentToken = localStorage.getItem('token');
          const tokenExpired = currentToken ? isJwtExpired(currentToken) : null;
          localStorage.removeItem('token');
          localStorage.removeItem('cnpj');
          let msg;
          if (tokenExpired === true) {
            msg = 'Sua sessão expirou após o período de inatividade. Por favor, faça login novamente.';
          } else if (currentToken) {
            msg = 'Sua sessão foi encerrada porque um novo acesso foi realizado em outro dispositivo, navegador ou aba. Faça login novamente.';
          } else {
            msg = 'Sua sessão expirou. Faça login novamente.';
          }
          sessionStorage.setItem('loginRedirectMessage', msg);
          window.location.href = '/';
        }
      }
      if (status === 403) {
        const data = error.response.data;
        const msg = data && data.message ? data.message : 'Acesso negado.';
        // Dispara evento para notificação global, se houver ouvinte
        window.dispatchEvent(new CustomEvent('app:error', { detail: { message: msg } }));
      }
    } catch (e) {
      // noop
    }
    return Promise.reject(error);
  }
);
